module.exports = __webpack_require__.p + "24a6c438085e3032b74d665139746b1e.jpg";